import { Injectable } from '@angular/core';
import { LocalFileDatasourceService } from 'datasource-service-lib';
import { forkJoin, from, map, mergeMap, Observable, of, toArray } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface ILocalDatasourceFile {
  contentType: string;
  filename: string;
  length: number;
  namespace: string;
  parameters: Map<string, object>;
  path: string[];
}

export interface ICombinedUploadResponse {
  response: ILocalDatasourceFile;
  originalFile: File;
}

@Injectable({ providedIn: 'root' })
export class LocalfileUploadService {

  constructor(
    private localFileDataSourceService: LocalFileDatasourceService
  ) {}

  uploadMergeFiles(files: any[], namespace: string): Observable<any> {
    const filesToUpload = files.filter((f) => f.file);
    if (filesToUpload.length === 0) {
      return of(true);
    }

    const fileUploads$: any[] = [];
    filesToUpload.forEach((file) => {
      // e.g. ends up in S3 Bucket (e.g. nh-data-test) - /kyloedev/<person-guid>/bw-think.png - /<guid.png>

      const filePath = `${namespace}/${file.belongsTo?.id}/${file.file.name}`;
      const fileParams = { path: filePath };
      fileUploads$.push(
        this.localFileDataSourceService.postFile(file.file, fileParams).pipe(
          tap((_) => console.log(`Uploaded ${file.file.name}`)),
          tap((s3FileData) => {
            // note: file.id is undefined as this file is NOT associated with the entity
            file.s3 = s3FileData;
            delete file.file;
          })
        )
      );
    });

    return forkJoin(fileUploads$);
  }

  uploadLocalFiles(files: File[], namespace: string , s3Path: string[]): Observable<ICombinedUploadResponse[] | undefined> {
    if (files.length === 0) {
      return of(undefined);
    }

    return from(files).pipe(
      mergeMap((file ) => {
        s3Path.push(file.name);
        const fileParams = { path: `${[namespace, ...s3Path].join('/')}` };
        return this.combineUploadResponse(file, fileParams);
      }),
      tap((_) => console.log('Uploaded', _)),
      toArray()
    );
  }

  private combineUploadResponse(file: File, fileParams: any): Observable<ICombinedUploadResponse> {
    return this.localFileDataSourceService.postFile(file, fileParams).pipe(
      map(response => ({
        response: response,
        originalFile: file
      })));
  }
}
